import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getTyresByProperties } from 'utils/api/articleSearchAPI'
import { createResultSelector, isPreviousSearchCategory, isSearchCategory } from 'utils/helper'
import { statusHandler, thunkActions } from 'utils/utils'
import { loggedOut } from 'utils/redux/commonActions'
import sliceStatus from 'utils/enums/sliceStatus'

export const searchTyres = createAsyncThunk('mcTyreSearch/search', async (criteria) => await getTyresByProperties(
	criteria.width,
	criteria.aspectRatio,
	criteria.diameter,
	criteria.secondaryWidth,
	criteria.secondaryAspectRatio,
	criteria.secondaryDiameter,
	criteria.articleText,
	criteria.motoBrand,	
	criteria.motoEngineCapacity,
	criteria.motoModel,
	null,
	criteria.tyreType,
	criteria.languageCode
))

const searchMcTyresActions = thunkActions(searchTyres)

const defaultCriteria = {
	tyreType: '85',
	width: '',
	aspectRatio: '',
	diameter: '',
	secondaryWidth: '',
	secondaryAspectRatio: '',
	secondaryDiameter: '',
	articleText: '',
	motoBrand: '',
	motoEngineCapacity: '',
	motoModel: '',	
}

const mcTyreSearch = createSlice({
	name: 'mcTyre',
	initialState: {
		status: 'idle',
		result: null,
		sortBy: null,
		ascending: null,
		criteria: defaultCriteria,
		filterIds: null,
		filterState: null
	},
	reducers: {
		setCriteria: (state, action) => {
			state.criteria[action.payload.name] = action.payload.value
		},
		clearCriteria: (state) => {
			state.criteria = defaultCriteria
		},
		setFilter: (state, action) => {
			state.filterIds = action.payload.articleIds
			state.filterState = action.payload.filterState
		},
		sortResult: (state, action) => {
			state.sortBy = action.payload.sortBy
			state.ascending = action.payload.ascending
		},
	},
	extraReducers: builder => {
		builder
			.addCase(loggedOut, state => {
				state.status = 'idle'
				state.result = null
				state.filterIds = null
				state.criteria = {
					tyreType: '85',
					width: '',
					aspectRatio: '',
					diameter: '',
					secondaryWidth: '',
					secondaryAspectRatio: '',
					secondaryDiameter: '',
					articleText: '',
					motoBrand: '',
					motoEngineCapacity: '',
					motoModel: '',
				}
			})
			.addCase(searchTyres.pending, state => {
				state.filterIds = null
				state.filterState = null
				state.result = null
				state.sortBy = null
				state.ascending = null
			})
			.addCase(searchTyres.fulfilled, (state, action) => {
				state.result = action.payload
			})
			.addMatcher(isPreviousSearchCategory('moto', 'tyre'), (state) => {
				state.status = sliceStatus.idle
			})
			.addMatcher(isSearchCategory('moto', 'tyre'), (state, action) => {
				state.status = sliceStatus.success
				state.result = action.payload
			})
			.addMatcher(searchMcTyresActions, statusHandler)
	}
})

export const selectCritiera = state => state.search.tyre.mcTyre.criteria
export const selectStatus = state => state.search.tyre.mcTyre.status
export const selectResult = state => state.search.tyre.mcTyre.result
export const selectSortBy = state => state.search.tyre.mcTyre.sortBy
export const selectAscending = state => state.search.tyre.mcTyre.ascending
export const selectFilterIds = state => state.search.tyre.mcTyre.filterIds
export const selectFilterState = state => state.search.tyre.mcTyre.filterState

export const selectProcessedResult = createResultSelector(
	selectResult, 
	selectFilterIds, 
	selectSortBy, 
	selectAscending 
)

export const { 
	setCriteria, 
	clearCriteria, 
	sortResult, 
	setFilter 
} = mcTyreSearch.actions

export default mcTyreSearch.reducer
